import React, { useState } from 'react'
import copy from '../assets/copy.svg'
import { toast } from 'react-toastify'

const TokenField = ({ containerClassName, labelFor, labelClassName, children, type = '', id = '', name = '', className = '', placeholder = '', required = false, value = '' }) => {
  const [copied, setCopied] = useState(false)
  const copyToClip = () => {
    navigator.clipboard.writeText(value)
    toast.info('Token is copied to clipboard')
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 1450)
  }

  return (
    <div className={`${containerClassName} my-6 mx-6`}>
      <label htmlFor={labelFor} className={`${labelClassName} block mb-2 text-sm font-bold text-black dark:text-black`}>{children}</label>
      <div className='flex flex-row max-w-lg w-full'>
        <input
          type={type}
          id={id}
          name={name}
          className={`${className} bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
          placeholder={placeholder}
          required={required}
          value={value}
          readOnly
        />
        <button disabled={copied} type='button' title='Copy Token' onClick={copyToClip} className='bg-gray-200 w-8 p-1 rounded-r-lg border border-gray-300 foucs:bg-gray-200 focus:border-gray-400 hover:bg-gray-300 hover:border-gray-400'>
          <img className='w-5' src={copy} alt='Click to copy' />
        </button>
      </div>
    </div>
  )
}

export default TokenField
